export default "__VITE_ASSET__PFKDq9p$__"